import { useState } from 'react';
import { Smartphone } from 'lucide-react';
import { Stage } from '@gmp/shared-ui';
import { navigate } from '../app/router';
import { adoptCredential, credentialFromHash } from '../net/identity';

/** Landing page of a "Continue on another device" link: confirm, then become that player here. */
export function DeviceScreen() {
  const [cred] = useState(() => credentialFromHash(window.location.hash));
  return (
    <Stage>
      <main className="flex-1 grid place-items-center safe-pad safe-top safe-bottom p-6">
        <div className="card p-6 max-w-md flex flex-col gap-4 text-center">
          <Smartphone size={40} className="self-center text-[var(--accent)]" aria-hidden />
          {cred ? (
            <>
              <h1 className="font-display font-black text-2xl">Continue here?</h1>
              <p className="text-mute">This device will play as you, with all your open parties. Any parties this device was in before stay on the other identity.</p>
              <button className="btn" data-testid="device-confirm" onClick={() => { adoptCredential(cred); history.replaceState(null, '', '/parties'); window.location.reload(); }}>Yes, continue here</button>
              <button className="btn btn-ghost btn-sm" onClick={() => { history.replaceState(null, '', '/'); navigate({ name: 'home' }, true); }}>No thanks</button>
            </>
          ) : (
            <>
              <h1 className="font-display font-black text-2xl">That link has expired</h1>
              <p className="text-mute">Open "Your parties" on your other device and make a fresh one.</p>
              <button className="btn" onClick={() => navigate({ name: 'home' }, true)}>Home</button>
            </>
          )}
        </div>
      </main>
    </Stage>
  );
}
